/**
 * VAT utility functions.
 * Provides helpers for VAT-related functionality.
 *
 * @module utils/vat-util
 */

/** List of country codes where VAT functionality is enabled */
const vatEnabledLocale = ['AT', 'BE', 'CH', 'DE', 'DK', 'ES', 'FR', 'GB', 'IE', 'IT', 'NL', 'NO', 'PT', 'SE', 'NZ']

/**
 * Checks if VAT functionality is enabled for a given country.
 *
 * @param country - The country code to check (e.g., 'DE', 'FR')
 * @returns True if VAT is enabled for the country, false otherwise
 *
 * @example
 * isVatEnabled('DE') // returns true
 * isVatEnabled('US') // returns false
 */
export const isVatEnabled = (country: string): boolean => vatEnabledLocale.includes(country?.toUpperCase())
